// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   GLOBAL LAYOUT
================================ */
.admin-container {
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #1a1a1a;
}

/* ================================
   HEADINGS
================================ */
.admin-container h1 {
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 24px;
  color: #0f172a;
}

.admin-container h2 {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 24px 0 12px;
  color: #1e293b;
}

/* ================================
   ORGANIZATION CARD
================================ */
.org-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
  margin-bottom: 32px;
  transition: box-shadow 0.2s ease;
}

.org-card:hover {
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.org-card h2 {
  margin-bottom: 12px;
}

/* ================================
   TABLE STYLING
================================ */
.admin-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}

.admin-table thead {
  background: #f8fafc;
}

.admin-table th {
  padding: 14px;
  font-weight: 600;
  font-size: 0.95rem;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.admin-table td {
  padding: 14px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.95rem;
}

.admin-table tr:hover td {
  background: #f8fafc;
}

/* ================================
   BUTTONS
================================ */
.btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-left: 12px;
}

.btn-edit {
  background: #3b82f6;
  color: white;
}

.btn-edit:hover {
  background: #2563eb;
}

.btn-save {
  background: #10b981;
  color: white;
}

.btn-save:hover {
  background: #059669;
}

.btn-cancel {
  background: #e2e8f0;
  color: #1e293b;
}

.btn-cancel:hover {
  background: #cbd5e1;
}

.btn-disable {
  background: #ef4444;
  color: white;
}

.btn-disable:hover {
  background: #dc2626;
}

.btn-enable {
  background: #10b981;
  color: white;
}

.btn-enable:hover {
  background: #059669;
}

/* Square icon variant of .btn (keeps the color class, swaps text for an icon) */
.btn-icon {
  width: 36px;
  min-width: 36px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1;
}

/* ================================
   CHECKBOXES
================================ */
.group-checkbox {
  margin-right: 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* ================================
   ERROR MESSAGE
================================ */
.error-message {
  color: #dc2626;
  background: #fef2f2;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  margin-bottom: 16px;
}

/* ================================
   LOADING STATE
================================ */
.loading {
  font-size: 1.2rem;
  padding: 40px;
  text-align: center;
  color: #475569;
}

.badge {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
}

.badge-pending {
  background: #fef3c7;
  color: #92400e;
}

.badge-registered {
  background: #d1fae5;
  color: #065f46;
}
.badge-disabled {
  background: #fee2e2;
  color: #991b1b;
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55); /* slate-900 with opacity */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal container */
.modal {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px 28px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.25);
  color: #1e293b;
  font-size: 15px;
}

/* Modal headings */
.modal h2,
.modal h3 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #0f172a;
}

/* Modal labels & inputs */
.modal label {
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
  font-weight: 600;
}

.modal input[type="number"] {
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
}

/* Modal actions */
.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/admin.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,uFAAuF;EACvF,cAAc;AAChB;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;kCAEkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;kCAEkC;AAClC;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC,EAAE,2BAA2B;EAC/D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,8CAA8C;EAC9C,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX","sourcesContent":["/* ================================\n   GLOBAL LAYOUT\n================================ */\n.admin-container {\n  padding: 32px;\n  max-width: 1200px;\n  margin: 0 auto;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  color: #1a1a1a;\n}\n\n/* ================================\n   HEADINGS\n================================ */\n.admin-container h1 {\n  font-size: 2.4rem;\n  font-weight: 700;\n  margin-bottom: 24px;\n  color: #0f172a;\n}\n\n.admin-container h2 {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 24px 0 12px;\n  color: #1e293b;\n}\n\n/* ================================\n   ORGANIZATION CARD\n================================ */\n.org-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.04);\n  margin-bottom: 32px;\n  transition: box-shadow 0.2s ease;\n}\n\n.org-card:hover {\n  box-shadow: 0 6px 18px rgba(0,0,0,0.08);\n}\n\n.org-card h2 {\n  margin-bottom: 12px;\n}\n\n/* ================================\n   TABLE STYLING\n================================ */\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 16px;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.04);\n}\n\n.admin-table thead {\n  background: #f8fafc;\n}\n\n.admin-table th {\n  padding: 14px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #475569;\n  border-bottom: 1px solid #e2e8f0;\n  text-align: left;\n}\n\n.admin-table td {\n  padding: 14px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.95rem;\n}\n\n.admin-table tr:hover td {\n  background: #f8fafc;\n}\n\n/* ================================\n   BUTTONS\n================================ */\n.btn {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  margin-left: 12px;\n}\n\n.btn-edit {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-edit:hover {\n  background: #2563eb;\n}\n\n.btn-save {\n  background: #10b981;\n  color: white;\n}\n\n.btn-save:hover {\n  background: #059669;\n}\n\n.btn-cancel {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.btn-cancel:hover {\n  background: #cbd5e1;\n}\n\n.btn-disable {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-disable:hover {\n  background: #dc2626;\n}\n\n.btn-enable {\n  background: #10b981;\n  color: white;\n}\n\n.btn-enable:hover {\n  background: #059669;\n}\n\n/* Square icon variant of .btn (keeps the color class, swaps text for an icon) */\n.btn-icon {\n  width: 36px;\n  min-width: 36px;\n  height: 34px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n/* ================================\n   CHECKBOXES\n================================ */\n.group-checkbox {\n  margin-right: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ================================\n   ERROR MESSAGE\n================================ */\n.error-message {\n  color: #dc2626;\n  background: #fef2f2;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  margin-bottom: 16px;\n}\n\n/* ================================\n   LOADING STATE\n================================ */\n.loading {\n  font-size: 1.2rem;\n  padding: 40px;\n  text-align: center;\n  color: #475569;\n}\n\n.badge {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.badge-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.badge-registered {\n  background: #d1fae5;\n  color: #065f46;\n}\n.badge-disabled {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55); /* slate-900 with opacity */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Modal container */\n.modal {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 24px 28px;\n  max-width: 480px;\n  width: 100%;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.25);\n  color: #1e293b;\n  font-size: 15px;\n}\n\n/* Modal headings */\n.modal h2,\n.modal h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  color: #0f172a;\n}\n\n/* Modal labels & inputs */\n.modal label {\n  display: block;\n  margin-top: 12px;\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\n.modal input[type=\"number\"] {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n}\n\n/* Modal actions */\n.modal-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
